module.exports = __webpack_public_path__ + "static/media/myTTT.ef98b19f.png";